import React, { Fragment } from "react";
import { createPortal } from "react-dom";

import SaitButton from "./SaitButton";
import SaitDialog from "./SaitDialog";
import { useDispatch, useSelector } from "react-redux";
import { unsetGlobalError } from "../store/globalMessageReducer";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { saitfecoreNs } from "../utils/Constants";

const SaitGlobalMessage = (props) => {
	const dispatch = useDispatch();
	const { t } = useTranslation(saitfecoreNs);

	const closeButtonRef = React.useRef(null);

	const globalMessage = useSelector((state) => state["globalMessage"]["globalMessage"]);

	const currentMessage = globalMessage.find((obj) => obj.module === props.module);

	React.useEffect(() => {
		if (currentMessage) {
			const timer = setTimeout(() => {
				closeButtonRef.current?.focus();
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [currentMessage]);

	return createPortal(
		<SaitDialog
			open={currentMessage}
			title={currentMessage?.title ? currentMessage?.title : currentMessage?.errorMessage ? t("error") : null}
			titleColor={currentMessage?.errorMessage ? "red" : null}
			width="xs"
			content={
				<Typography align="center" sx={{ whiteSpace: "pre-line" }}>
					{currentMessage?.errorMessage || currentMessage?.message}
				</Typography>
			}
			actions={
				<Fragment>
					<Box sx={{ flexGrow: 1 }} />
					{/* All'apertura della dialog metto il focus sul tasto di chiusura 
					Uso il div per evitare l'animazione di focus sul tasto che quando rimane fissa è brutta */}
					<div ref={closeButtonRef} tabIndex={-1} style={{ outline: "none" }} onKeyDown={(e) => e.key === "Enter" && dispatch(unsetGlobalError())}>
						<SaitButton text={t("close")} onClick={() => dispatch(unsetGlobalError())} />
					</div>
					<Box sx={{ flexGrow: 1 }} />
				</Fragment>
			}
		/>,
		document.body,
	);
};

export default SaitGlobalMessage;
